import { Button } from '@components/core-ui/form-elements/buttons/Button';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import LoadingIcon from '@components/icons/Loading.svg';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { useState } from 'react';
import { TProps } from './types/TProps';

export const ConfirmCloudLayoutResetModal = ({ onCancel, onSuccess }: TProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const confirm = async () => {
    setIsSubmitting(true);

    try {
      await onSuccess();
    } catch {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalWrapper width="487px">
      <ModalTitle>Confirm Reset</ModalTitle>

      <div className="flex flex-col gap-3 text-base leading-6 text-[var(--color-text)]">
        <p className="m-0">
          This action will <strong>permanently delete all existing job versions and all edits</strong> associated with
          them.
        </p>
        <p className="m-0">Are you sure you want to apply the new Cloud Layout and regenerate the job?</p>
      </div>

      <div className="mt-5 flex justify-end gap-2.5">
        <OutlinedButton onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </OutlinedButton>
        <Button
          onClick={confirm}
          disabled={isSubmitting}
          className="flex min-w-[170px] items-center justify-center gap-2"
        >
          {isSubmitting ? <LoadingIcon className="h-4 w-4 shrink-0 animate-spin" /> : null}
          Apply Cloud Layout
        </Button>
      </div>
    </ModalWrapper>
  );
};
